<template>
  <v-container fluid grid-list-lg>
    <!--<v-btn @click.prevent="loadResults">refresh</v-btn>-->
    <v-progress-circular indeterminate color="primary" v-show="loading"></v-progress-circular>
    <v-alert
      v-if="!loading && results.length === 0"
      :value="true"
      color="info"
      icon="info"
      outline
    >Nu exista rezultate.</v-alert>
    <v-layout row wrap>
        <v-flex xs12 v-for="rez in results" :key="rez.id_oferta">
          <result :offer="rez" :query="query"/>
        </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import {mapGetters} from 'vuex';
  import Result from './Result.vue';
  import {loader} from '@/modules/gaz/index.js';

  export default {
    data() {
      return {
        loading: false,
        query: undefined,
        results: []
      }
    },
    computed: {
      ...mapGetters(['language'])
    },
    methods: {
      loadResults() {
        this.loading = true;

        return loader(this.language, this.query)
          .then(r => r.json())
          .then(results => {
            this.results = results.data;
          })
          .catch(e => {
            console.log(e);
          })
          .then(() => {
            this.loading = false;
          });
      }
    },
    mounted() {
      this.query = this.$route.query;
      this.loadResults();
    },
    beforeRouteUpdate(to, from, next) {
      this.query = to.query;
      this.loadResults();
      next();
    },
    components: {
      Result
    }
  }
</script>
